import AsyncSelect from 'react-select/async';
import createSelect from './createSelect';
export default createSelect(AsyncSelect);